import React from 'react';
import { Link } from 'react-router-dom';
import { bandMembers } from '../data/band';
import BandMemberList from './BandMemberList';
import '../styles/components/AboutSummary.css';

interface AboutSummaryProps {
  showFullContent?: boolean;
}

const AboutSummary: React.FC<AboutSummaryProps> = ({ showFullContent = false }) => {
  return (
    <div className="about-summary">
      <h2 className="about-summary-title">About</h2>
      <div className="about-summary-content">
        <p className="about-summary-story">
        We're an Albert Lea trio that's been rocking the local scene since 2024. With guitar, bass, drums, and a knack for swapping instruments on the fly, we bring a high‑energy blend of rock to every show. Whether you're into head‑banging riffs or sing‑along hooks, we've got a little bit of everything to keep the crowd moving.
        </p>
        <p className="about-summary-story">
          We play songs from a variety of genres like rock, metal, alternative, pop, and more.
        </p>
        
        <BandMemberList 
          members={bandMembers} 
          showFullContent={showFullContent} 
        />
      </div>

      
      <br></br>

      <p style={{ 
        textAlign: 'center', 
        fontSize: '1.3rem', 
        fontWeight: 'bold', 
        color: 'var(--accent-color)',
        marginBottom: 'var(--spacing-md)',
        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
      }}>
        Ready to book a show?
      </p>


      <div style={{ textAlign: 'center', marginTop: 'var(--spacing-lg)' }}>
        <Link to="/contact" className="cta-button">Contact us today!</Link>
      </div>
    </div>
  );
};

export default AboutSummary;
